import { CM0027_1SliceType } from './../type/Presenter';
import { createSlice } from '@reduxjs/toolkit';

const initialState: CM0027_1SliceType = {
    loading: false,
    isVisible: false,
    refresh: false,
    typeModal: false,
    parentCode: {
        categoryId: 13,
        documentProjectOutsourceCostConstructionSummaryDataId: 104,
    },
    headerData: {
        traderName: null,
        contractWorkName: null,
        targetPeriod: null,
    },
    title: null,
};

export const cm0027_1Slice = createSlice({
    name: 'cm0027_1',
    initialState,
    reducers: {
        resetCM0027_1: () => initialState,
        setLoadingCM0027_1: (state, action) => {
            state.loading = action.payload;
        },
        setIsVisibleCM0027_1: (state, action) => {
            state.isVisible = action.payload;
        },
        setRefreshCM0027_1: (state) => {
            state.refresh = !state.refresh;
        },
        setTypeModalCM0027_1: (state, action) => {
            state.typeModal = action.payload;
        },
        setParentCodeCM0027_1: (state, action) => {
            state.parentCode = action.payload;
        },
        setHeaderDataCM0027_1: (state, action) => {
            state.headerData = action.payload;
        },
        setTitleCM0027_1: (state, action) => {
            state.title = action.payload;
        },
    },
});

export const {
    setLoadingCM0027_1,
    setIsVisibleCM0027_1,
    resetCM0027_1,
    setRefreshCM0027_1,
    setTypeModalCM0027_1,
    setParentCodeCM0027_1,
    setHeaderDataCM0027_1,
    setTitleCM0027_1,
} = cm0027_1Slice.actions;

export default cm0027_1Slice.reducer;
